'use strict';


export default () => {
	const categorySliders = document.querySelectorAll('.m-scroll-nav');

	for (const categorySlider of categorySliders) {

		const slider = categorySlider.querySelector('.m-scroll-nav__list');

		if (slider) {

			const activeItem = slider.querySelector('.active');

			if (activeItem) {
				slider.scrollTo({ left: activeItem.offsetLeft, behavior: 'smooth' });
			}

			categorySlider.addEventListener('click', (e) => {
				const target = e.target;

				if (target && target.classList.contains('m-scroll-nav__link')) {

					const scrollPosition = target.offsetLeft;

					const activeLink = categorySlider.querySelector('.active');

					if (activeLink) {
						activeLink.classList.remove('active', 'disabled');
					}

					slider.scrollTo({ left: scrollPosition, behavior: 'smooth' });
					target.classList.add('active');

				}

			});
		}
	}

};